<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Dispatch orders</h1>
          </v-col>
        </v-row>
        <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="2">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="3">
            <v-menu
              v-model="date_menu"
              close-on-content-click
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  readonly
                  prepend-icon="fas fa-calendar"
                  label="Date"
                  @click.native="date_menu = true"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @input="date_menu=false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="12" md="2">
            <v-switch
              style="justify-content: center"
              color="blue"
              v-model="showClosed"
              label="Show Closed"
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="12" md="2">
            <v-select
              label="Choose a depot"
              :items="depots"
              item-text="name"
              item-value="id"
              v-model="depot"
              prepend-icon="fas fa-warehouse"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="12" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="12" md="2" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn v-if="isInventoryManager" class="mx-2" fab dark color="blue lighten-1" @click="newDispatchOrder"
                       v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new dispatch order</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :search="search"
        :loading="loading"
        :items="renderedOrders"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center" v-if="header.text !== 'Actions'" v-for="(header, index) in headers"
                :key="index">{{props.item[header.value]}}
            </td>
            <td class="text-center" v-if="isInventoryManager">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <CreateDispatchOrder
      :dispatchOrder="dispatchOrder"
      :createDispatchOrderDialog="createDispatchOrderDialog"
      v-on:updateDataTable="updateDataTable()"
      @close="closeCreateDispatchOrderDialog"
      @save="CreateDispatchOrder"
      @closeItem="closeItemDialog"
      @openItemsDialog="openItemDialog"
      :itemsDialog="itemsDialog"
      :editedIndexDispatchOrder="editedIndexDispatchOrder"
      :isSaved="isSaved"
    ></CreateDispatchOrder>

  </div>
</template>

<script>
    import axios from 'axios';
    import CreateDispatchOrder from "./CreateDispatchOrder";

    export default {
        name: "DispatchOrders",
        components: {
            CreateDispatchOrder
        },
        data() {
            return {
                editDialog: false,
                showClosed: false,
                search: '',
                loading: false,
                pagination: {rowsPerPage: 10},
                reload: false,
                date: (new Date()).toISOString().split('T')[0],
                date_menu: false,
                depots: null,
                isSaved: false,
                depot: 1,
                headers: [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'ETA', value: 'eta', align: 'center', sortable: true},
                    {text: 'Destination', value: 'destination_code', align: 'center', sortable: true},
                    {text: 'Reference', value: 'receiver_reference', align: 'center', sortable: true},
                    {
                        text: 'Pallets Requested',
                        value: 'pallets_requested',
                        align: 'center',
                        sortable: true,
                    },
                    {
                        text: 'Pallets Dispatched',
                        value: 'pallets_dispatched',
                        align: 'center',
                        sortable: true,
                    },
                    {
                        text: 'Pallets Available',
                        value: 'pallets_available',
                        align: 'center',
                        sortable: true,
                    },
                    {text: 'Items Requested', value: 'requested_items', align: 'center', sortable: true},
                    {
                        text: 'Items Dispatched',
                        value: 'dispatched_items',
                        align: 'center',
                        sortable: true,
                    },
                    {text: 'Exchange', value: 'exchange_pallets', align: 'center', sortable: true},
                    {text: 'Carrier', value: 'carrier', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                editedIndexDispatchOrder: -1,
                createDispatchOrderDialog: false,
                isEditing: false,
                itemsDialog: null,
                dispatchOrder: {
                    id: 0,
                    client_id: null,
                    client_name: null,
                    depot_id: null,
                    date: null,
                    eta: null,
                    number: null,
                    sorter_run_id: null,
                    sorter_run_name: null,
                    destination_code: null,
                    receiver_name: null,
                    receiver_address: null,
                    receiver_suburb: null,
                    receiver_state: null,
                    receiver_postcode: null,
                    receiver_reference: null,
                    notes: null,
                    num_pallets: null,
                    exchange_pallets: true,
                    carrier: null,
                    carrier_reference: null,
                    requested_items: null,
                    dispatched_items: null,
                    pallets_requested: null,
                    pallets_dispatched: null,
                    pallets_available: null,
                    approved: null,
                    approved_by: null,
                    closed: null,
                    created: null,
                    edited: null,
                },
                default: {
                    id: 0,
                    client_id: null,
                    client_name: null,
                    depot_id: 1,
                    date: null,
                    eta: null,
                    number: null,
                    sorter_run_id: null,
                    sorter_run_name: null,
                    destination_code: null,
                    receiver_name: null,
                    receiver_address: null,
                    receiver_suburb: null,
                    receiver_state: null,
                    receiver_postcode: null,
                    receiver_reference: null,
                    notes: null,
                    num_pallets: null,
                    exchange_pallets: true,
                    carrier: null,
                    carrier_reference: null,
                    requested_items: null,
                    dispatched_items: null,
                    pallets_requested: null,
                    pallets_dispatched: null,
                    pallets_available: null,
                    approved: null,
                    approved_by: null,
                    closed: null,
                    created: null,
                    edited: null,
                },
                timer: '',
            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000);
            this.getDepots();
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            renderedOrders() {
                if (this.orders === null || this.orders === undefined) return [];
                if (!this.showClosed) {
                    return this.orders.filter((order) => {
                        return !order.closed;
                    })
                } else {
                    return this.orders;
                }
            },
            isAdmin() {
                return this.$store.getters['auth/hasPermission']('wms_admin');
            },
        },
        asyncComputed: {
            async orders() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/dispatchorders?depot=' + this.depot + '&date=' + this.date)
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                this.reload = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.reload = false;
                            return [];
                        });
                }
            },
        },
        methods: {
            isInventoryManager() {
                return this.$store.getters['auth/inventory_manage'];
            },
            newDispatchOrder() {
                this.isSaved = false;
                this.editedIndexDispatchOrder = -1;
                this.dispatchOrder = Object.assign({}, this.default);
                this.createDispatchOrderDialog = true;
            },
            CreateDispatchOrder() {
                let body = this.dispatchOrder;

                if (this.editedIndexDispatchOrder > -1) {
                    // EDIT
                    axios.put(process.env.API_URL + '/dispatchorders/' + this.dispatchOrder.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Changes saved');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        });
                    this.isSaved = true;
                } else {
                    // CREATE
                    axios.post(process.env.API_URL + '/dispatchorders', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create successful');
                            this.dispatchOrder.id = response.data.id;
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        });
                    this.itemsDialog = true;
                    this.isSaved = true;
                }
            },
            // @vuese
            // Gets all the depots
            getDepots() {
                axios.get(process.env.API_URL + '/depots?wms=true')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            editRow(item) {
                this.dispatchOrder = Object.assign({}, item);
                this.editedIndexDispatchOrder = this.orders.indexOf(item);
                this.createDispatchOrderDialog = true;
            },
            closeCreateDispatchOrderDialog() {
                this.dispatchOrder = Object.assign({}, this.default);
                this.createDispatchOrderDialog = false;
                this.reload = !this.reload;
            },
            closeItemDialog() {
                this.itemsDialog = false;
            },
            openItemDialog() {
                this.itemsDialog = true;
            },
            updateDataTable() {
                this.reload = !this.reload;
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/DispatchOrders.vue